"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FORMAT_NAME = exports.CUSTOM_FORMAT_TABLE = exports.MSO_FORMAT_MAP = exports.SUPPORT_CURRENCY_LIST = exports.COLOR_MAP = exports.MONTHS = exports.DAYS = exports.RESERVED_NUMBER_FORMAT_NUM = exports.BUILDIN_NUMBER_FORMAT = exports.INVALID_VALUE = exports.DEFAULT_FORMAT_PATTERN = exports.DEFAULT_FORMAT = void 0;
var DEFAULT_FORMAT_PATTERN = 'General';
exports.DEFAULT_FORMAT_PATTERN = DEFAULT_FORMAT_PATTERN;
var DEFAULT_FORMAT = {
    id: 0,
    pattern: DEFAULT_FORMAT_PATTERN,
};
exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
var INVALID_VALUE = '#INVALID_DATE!';
exports.INVALID_VALUE = INVALID_VALUE;
var RESERVED_NUMBER_FORMAT_NUM = 164;
exports.RESERVED_NUMBER_FORMAT_NUM = RESERVED_NUMBER_FORMAT_NUM;
var BUILDIN_NUMBER_FORMAT = [
    DEFAULT_FORMAT_PATTERN,
    '0',
    '0.00',
    '#,##0',
    '#,##0.00',
    '\\¥#,##0;\\¥-#,##0',
    '\\¥#,##0;]\\¥-#,##0',
    '\\¥#,##0.00;\\¥-#,##0.00',
    '\\¥#,##0.00;]\\¥-#,##0.00',
    '0%',
    '0.00%',
    '0.00E+00',
    '# ?/?',
    '# ??/??',
    'yyyy/m/d',
    'd-mmm-yy',
    'd-mmm',
    'mmm-yy',
    'h:mm AM/PM',
    'h:mm:ss AM/PM',
    'h:mm',
    'hh:mm:ss',
    'yyyy/m/d h:mm',
    '\\$#,##0_);(\\$#,##0)',
    '\\$#,##0_);](\\$#,##0)',
    '\\$#,##0.00_);(\\$#,##0.00)',
    '\\$#,##0.00_);](\\$#,##0.00)',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'm"月"d"日"',
    'm/d/yy',
    'yyyy"年"m"月"d"日"',
    'h"时"mm"分"',
    'h"时"mm"分"ss"秒"',
    '上午/下午h"时"mm"分"',
    '上午/下午h"时"mm"分"ss"秒"',
    'yyyy"年"m"月"',
    '#,##0;-#,##0',
    '#,##0;]-#,##0',
    '#,##0.00;-#,##0.00',
    '#,##0.00;]-#,##0.00',
    '_ * #,##0_ ;_ * -#,##0_ ;_ * "-"_ ;_ @_ ',
    '_ \\¥* #,##0_ ;_ \\¥* -#,##0_ ;_ \\¥* "-"_ ;_ @_ ',
    '_ * #,##0.00_ ;_ * -#,##0.00_ ;_ * "-"??_ ;_ @_ ',
    '_ \\¥* #,##0.00_ ;_ \\¥* -#,##0.00_ ;_ \\¥* "-"??_ ;_ @_ ',
    'mm:ss',
    'mm:ss' /** 示从1900-1-0日开始到数值代表时间的小时数 */,
    'mm:ss.0',
    '##0.0E+0',
    '@',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'm"月"d"日"',
    '上午/下午h"时"mm"分"',
    '上午/下午h"时"mm"分"ss"秒"',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    '0',
    '0.00',
    '#,##0',
    '#,##0.00',
    '\\¥#,##0;\\¥-#,##0',
    '\\¥#,##0;]\\¥-#,##0',
    '\\¥#,##0.00;\\¥-#,##0.00',
    '\\¥#,##0.00;]\\¥-#,##0.00',
    '0%',
    '0.00%',
    '# ?/?',
    '# ??/??',
    'yyyy/m/d',
    'yyyy/m/d',
    'd-mmm-yy',
    'd-mmm',
    'mmm-yy',
    'h:mm',
    'h:mm:ss',
    'yyyy/m/d h:mm',
    'mm:ss',
    'mm:ss',
    'mm:ss.0',
];
exports.BUILDIN_NUMBER_FORMAT = BUILDIN_NUMBER_FORMAT;
var DAYS = [
    ['Sun', 'Sunday', '星期天', '周日'],
    ['Mon', 'Monday', '星期一', '周一'],
    ['Tue', 'Tuesday', '星期二', '周二'],
    ['Wed', 'Wednesday', '星期三', '周三'],
    ['Thu', 'Thursday', '星期四', '周四'],
    ['Fri', 'Friday', '星期五', '周五'],
    ['Sat', 'Saturday', '星期六', '周六'],
];
exports.DAYS = DAYS;
var MONTHS = [
    ['J', 'Jan', 'January'],
    ['F', 'Feb', 'February'],
    ['M', 'Mar', 'March'],
    ['A', 'Apr', 'April'],
    ['M', 'May', 'May'],
    ['J', 'Jun', 'June'],
    ['J', 'Jul', 'July'],
    ['A', 'Aug', 'August'],
    ['S', 'Sep', 'September'],
    ['O', 'Oct', 'October'],
    ['N', 'Nov', 'November'],
    ['D', 'Dec', 'December'],
];
exports.MONTHS = MONTHS;
var COLOR_MAP = {
    Black: '#000000',
    Blue: '#0000FF',
    Cyan: '#00FFFF',
    Green: '#008000',
    Magenta: '#FF00FF',
    Red: '#FF0000',
    White: '#FFFFFF',
    Yellow: '#FFFF00',
    黑色: '#000000',
    蓝色: '#0000FF',
    蓝绿色: '#00FFFF',
    绿色: '#008000',
    洋红色: '#FF00FF',
    红色: '#FF0000',
    白色: '#FFFFFF',
    黄色: '#FFFF00',
    颜色0: '#00000000',
    颜色1: '#00FFFFFF',
    颜色2: '#00FF0000',
    颜色3: '#0000FF00',
    颜色4: '#000000FF',
    颜色5: '#00FFFF00',
    颜色6: '#00FF00FF',
    颜色7: '#0000FFFF',
    颜色8: '#00000000',
    颜色9: '#00FFFFFF',
    颜色10: '#00FF0000',
    颜色11: '#0000FF00',
    颜色12: '#000000FF',
    颜色13: '#00FFFF00',
    颜色14: '#00FF00FF',
    颜色15: '#0000FFFF',
    颜色16: '#00800000',
    颜色17: '#00008000',
    颜色18: '#00000080',
    颜色19: '#00808000',
    颜色20: '#00800080',
    颜色21: '#00008080',
    颜色22: '#00C0C0C0',
    颜色23: '#00808080',
    颜色24: '#009999FF',
    颜色25: '#00993366',
    颜色26: '#00FFFFCC',
    颜色27: '#00CCFFFF',
    颜色28: '#00660066',
    颜色29: '#00FF8080',
    颜色30: '#000066CC',
    颜色31: '#00CCCCFF',
    颜色32: '#00000080',
    颜色33: '#00FF00FF',
    颜色34: '#00FFFF00',
    颜色35: '#0000FFFF',
    颜色36: '#00800080',
    颜色37: '#00800000',
    颜色38: '#00008080',
    颜色39: '#000000FF',
    颜色40: '#0000CCFF',
    颜色41: '#00CCFFFF',
    颜色42: '#00CCFFCC',
    颜色43: '#00FFFF99',
    颜色44: '#0099CCFF',
    颜色45: '#00FF99CC',
    颜色46: '#00CC99FF',
    颜色47: '#00FFCC99',
    颜色48: '#003366FF',
    颜色49: '#0033CCCC',
    颜色50: '#0099CC00',
    颜色51: '#00FFCC00',
    颜色52: '#00FF9900',
    颜色53: '#00FF6600',
    颜色54: '#00666699',
    颜色55: '#00969696',
    颜色56: '#00003366',
    颜色57: '#00339966',
    颜色58: '#00003300',
    颜色59: '#00333300',
    颜色60: '#00993300',
    颜色61: '#00993366',
    颜色62: '#00333399',
    颜色63: '#00333333',
    Color0: '#00000000',
    Color1: '#00FFFFFF',
    Color2: '#00FF0000',
    Color3: '#0000FF00',
    Color4: '#000000FF',
    Color5: '#00FFFF00',
    Color6: '#00FF00FF',
    Color7: '#0000FFFF',
    Color8: '#00000000',
    Color9: '#00FFFFFF',
    Color10: '#00FF0000',
    Color11: '#0000FF00',
    Color12: '#000000FF',
    Color13: '#00FFFF00',
    Color14: '#00FF00FF',
    Color15: '#0000FFFF',
    Color16: '#00800000',
    Color17: '#00008000',
    Color18: '#00000080',
    Color19: '#00808000',
    Color20: '#00800080',
    Color21: '#00008080',
    Color22: '#00C0C0C0',
    Color23: '#00808080',
    Color24: '#009999FF',
    Color25: '#00993366',
    Color26: '#00FFFFCC',
    Color27: '#00CCFFFF',
    Color28: '#00660066',
    Color29: '#00FF8080',
    Color30: '#000066CC',
    Color31: '#00CCCCFF',
    Color32: '#00000080',
    Color33: '#00FF00FF',
    Color34: '#00FFFF00',
    Color35: '#0000FFFF',
    Color36: '#00800080',
    Color37: '#00800000',
    Color38: '#00008080',
    Color39: '#000000FF',
    Color40: '#0000CCFF',
    Color41: '#00CCFFFF',
    Color42: '#00CCFFCC',
    Color43: '#00FFFF99',
    Color44: '#0099CCFF',
    Color45: '#00FF99CC',
    Color46: '#00CC99FF',
    Color47: '#00FFCC99',
    Color48: '#003366FF',
    Color49: '#0033CCCC',
    Color50: '#0099CC00',
    Color51: '#00FFCC00',
    Color52: '#00FF9900',
    Color53: '#00FF6600',
    Color54: '#00666699',
    Color55: '#00969696',
    Color56: '#00003366',
    Color57: '#00339966',
    Color58: '#00003300',
    Color59: '#00333300',
    Color60: '#00993300',
    Color61: '#00993366',
    Color62: '#00333399',
    Color63: '#00333333',
};
exports.COLOR_MAP = COLOR_MAP;
var SUPPORT_CURRENCY_LIST = [
    {
        symbol: '￥',
        type: 'currency-chs',
        pattern: '"¥"#,##0_);[Red]\\("¥"#,##0\\)',
        pattern_decimal: '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',
    },
    {
        symbol: '¥',
        type: 'currency-chs',
        pattern: '"¥"#,##0_);[Red]\\("¥"#,##0\\)',
        pattern_decimal: '"¥"#,##0.00_);[Red]\\("¥"#,##0.00\\)',
    },
    {
        symbol: 'HK$',
        type: 'currency-hk',
        pattern: '[$HK$-C04]#,##0_);[Red]\\([$HK$-C04]#,##0\\)',
        pattern_decimal: '[$HK$-C04]#,##0.00_);[Red]\\([$HK$-C04]#,##0.00\\)',
    },
    {
        symbol: '$',
        type: 'currency-en',
        pattern: '\\$#,##0_);[Red]\\(\\$#,##0\\)',
        pattern_decimal: '\\$#,##0.00_);[Red]\\(\\$#,##0.00\\)',
    },
    {
        symbol: 'US$',
        type: 'currency-en',
        pattern: '\\U\\S\\$#,##0_);[Red]\\(\\U\\S\\$#,##0\\)',
        pattern_decimal: '\\U\\S\\$#,##0.00_);[Red]\\(\\U\\S\\$#,##0.00\\)',
    },
    {
        symbol: '€',
        type: 'currency-eu',
        pattern: '#,##0\€_);[Red]\(#,##0\€\)',
        pattern_decimal: '#,##0.00\€_);[Red]\(#,##0.00\€\)',
    },
    {
        symbol: '€',
        type: 'currency-eu',
        pattern: '\€#,##0_);[Red]\(\€#,##0\)',
        pattern_decimal: '\€#,##0.00_);[Red]\(\€#,##0.00\)',
    },
    {
        symbol: '£',
        type: 'currency-uk',
        pattern: '\£#,##0_);[Red]\(\£#,##0\)',
        pattern_decimal: '\£#,##0.00_);[Red]\(\£#,##0.00\)',
    },
];
exports.SUPPORT_CURRENCY_LIST = SUPPORT_CURRENCY_LIST;
var MSO_FORMAT_MAP = {
    Standard: '#,##0.00',
    Scientific: '0.00E+00',
    Percent: '0.00%',
    'Short Date': 'yyyy/m/d',
    'Long Date': 'yyyy"年"m"月"d"日"',
    'General Date': 'yyyy/m/d hh:mm',
    'Medium Date': 'd-mmm-yy',
    'Long Time': 'h:mm:ss AM/PM',
    'Medium Time': 'h:mm AM/PM',
    'Short Time': 'hh:mm',
    'AM/PMh"时"mm"分"': '上午/下午h"时"mm"分"',
    'AM/PMh"时"mm"分"ss"秒"': '上午/下午h"时"mm"分"ss"秒"',
    Fixed: '#,##0.00_ ;@',
};
exports.MSO_FORMAT_MAP = MSO_FORMAT_MAP;
// 自定义格式串表
var CUSTOM_FORMAT_TABLE = [
    { label: 'G/通用格式', formatData: 'General' },
    { label: '0', formatData: '0' },
    { label: '0.00', formatData: '0.00' },
    { label: '#,##0', formatData: '#,##0' },
    { label: '#,##0.00', formatData: '#,##0.00' },
    { label: '#,##0;-#,##0', formatData: '#,##0;-#,##0' },
    { label: '#,##0;[Red]-#,##0', formatData: '#,##0;[Red]-#,##0' },
    { label: '#,##0.00;-#,##0.00', formatData: '#,##0.00;-#,##0.00' },
    { label: '#,##0.00;[Red]-#,##0.00', formatData: '#,##0.00;[Red]-#,##0.00' },
    { label: '¥#,##0;¥-#,##0', formatData: '"¥"#,##0;"¥"-#,##0' },
    { label: '¥#,##0;[Red]¥-#,##0', formatData: '"¥"#,##0;[Red]"¥"-#,##0' },
    { label: '¥#,##0.00;¥-#,##0.00', formatData: '"¥"#,##0.00;"¥"-#,##0.00' },
    {
        label: '¥#,##0.00;[Red]¥-#,##0.00',
        formatData: '"¥"#,##0.00;[Red]"¥"-#,##0.00',
    },
    { label: '0%', formatData: '0%' },
    { label: '0.00%', formatData: '0.00%' },
    { label: '0.00E+00', formatData: '0.00E+00' },
    { label: '##0.0E+0', formatData: '##0.0E+0' },
    { label: '# ?/?', formatData: '# ?/?' },
    { label: '# ??/??', formatData: '# ??/??' },
    { label: '$#,##0_);($#,##0)', formatData: '$#,##0_);($#,##0)' },
    { label: '$#,##0_);[Red]($#,##0)', formatData: '$#,##0_);[Red]($#,##0)' },
    { label: '$#,##0.00_);($#,##0.00)', formatData: '$#,##0.00_);($#,##0.00)' },
    {
        label: '$#,##0.00_);[Red]($#,##0.00)',
        formatData: '$#,##0.00_);[Red]($#,##0.00)',
    },
    { label: 'yyyy"年"m"月"', formatData: 'yyyy"年"m"月"' },
    { label: 'm"月"d"日"', formatData: 'm"月"d"日"' },
    { label: 'yyyy/m/d', formatData: 'yyyy/m/d' },
    { label: 'yyyy"年"m"月"d"日"', formatData: 'yyyy"年"m"月"d"日"' },
    { label: 'm/d/yy', formatData: 'm/d/yy' },
    { label: 'd-mmm-yy', formatData: 'd-mmm-yy' },
    { label: 'd-mmm', formatData: 'd-mmm' },
    { label: 'mmm-yy', formatData: 'mmm-yy' },
    { label: 'h:mm AM/PM', formatData: 'h:mm AM/PM' },
    { label: 'h:mm:ss AM/PM', formatData: 'h:mm:ss AM/PM' },
    { label: 'h:mm', formatData: 'h:mm' },
    { label: 'h:mm:ss', formatData: 'h:mm:ss' },
    { label: 'h"时"mm"分"', formatData: 'h"时"mm"分"' },
    { label: 'h"时"mm"分"ss"秒"', formatData: 'h"时"mm"分"ss"秒"' },
    { label: '上午/下午h"时"mm"分"', formatData: '上午/下午h"时"mm"分"' },
    {
        label: '上午/下午h"时"mm"分"ss"秒"',
        formatData: '上午/下午h"时"mm"分"ss"秒"',
    },
    { label: 'yyyy/m/d h:mm', formatData: 'yyyy/m/d h:mm' },
    { label: 'mm:ss', formatData: 'mm:ss' },
    { label: 'mm:ss.0', formatData: 'mm:ss.0' },
    { label: '@', formatData: '@' },
    { label: '[h]:mm:ss', formatData: '[h]:mm:ss' },
];
exports.CUSTOM_FORMAT_TABLE = CUSTOM_FORMAT_TABLE;
var NUMBER_FORMAT_TYPE;
(function (NUMBER_FORMAT_TYPE) {
    // NUMBER_FORMAT_TYPE_UNSPECIFIED,
    NUMBER_FORMAT_TYPE["GENERAL"] = "auto";
    NUMBER_FORMAT_TYPE["TEXT"] = "text";
    NUMBER_FORMAT_TYPE["NUMBER"] = "number";
    NUMBER_FORMAT_TYPE["PERCENT"] = "percent";
    NUMBER_FORMAT_TYPE["CURRENCY"] = "currency";
    NUMBER_FORMAT_TYPE["DATE"] = "date";
    NUMBER_FORMAT_TYPE["TIME"] = "time";
    NUMBER_FORMAT_TYPE["DATE_TIME"] = "date-time";
    NUMBER_FORMAT_TYPE["FRACTION"] = "fraction";
    NUMBER_FORMAT_TYPE["SCIENTIFIC"] = "scientific";
    NUMBER_FORMAT_TYPE["ACCOUNTING"] = "accounting";
    NUMBER_FORMAT_TYPE["SPECIAL"] = "special";
    NUMBER_FORMAT_TYPE["CUSTOM"] = "custom";
})(NUMBER_FORMAT_TYPE || (NUMBER_FORMAT_TYPE = {}));
var NUMBER_FORMAT_NAME = [
    { type: NUMBER_FORMAT_TYPE.GENERAL, name: '常规' },
    { type: NUMBER_FORMAT_TYPE.TEXT, name: '文本' },
    { type: NUMBER_FORMAT_TYPE.NUMBER, name: '数值' },
    { type: NUMBER_FORMAT_TYPE.PERCENT, name: '百分比' },
    { type: NUMBER_FORMAT_TYPE.SCIENTIFIC, name: '科学记数' },
    { type: NUMBER_FORMAT_TYPE.CURRENCY, name: '货币' },
    { type: NUMBER_FORMAT_TYPE.TIME, name: '时间' },
    { type: NUMBER_FORMAT_TYPE.DATE, name: '日期' },
    { type: NUMBER_FORMAT_TYPE.DATE_TIME, name: '日期' },
    { type: NUMBER_FORMAT_TYPE.ACCOUNTING, name: '会计专用' },
    { type: NUMBER_FORMAT_TYPE.FRACTION, name: '分数' },
    { type: NUMBER_FORMAT_TYPE.SPECIAL, name: '特殊' },
    { type: NUMBER_FORMAT_TYPE.CUSTOM, name: '自定义' },
];
exports.NUMBER_FORMAT_NAME = NUMBER_FORMAT_NAME;
//# sourceMappingURL=Constant.js.map